import { darken, rgba } from 'polished';
import styled, { DefaultTheme } from 'styled-components';

import { getFieldColorFromStatus } from '../common/helpers/getFieldColorFromStatus';

export const $OptionLine = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
`;

export const $BoldOptionName = styled.div`
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
`;

export const $OptionDescription = styled.div`
  font-size: ${({ theme }) => theme.fonts.size.ultraSmall};
  line-height: 1.2;
  color: ${({ theme }) => theme.colors.paragraphTextColor};
`;
export const $SelectWrapper = styled.div`
  flex: 1;
  width: 100%;
`;

export const getInputBorderColor = (
  { isFocused, selectProps }: any,
  theme: DefaultTheme,
  fallback: string,
) => {
  const { status } = selectProps;
  const colorFromStatus = getFieldColorFromStatus({ status, theme });

  if (colorFromStatus) {
    return colorFromStatus;
  }

  if (isFocused) {
    return theme.colors.primary;
  }

  return fallback;
};

export const getInputBorderHoverColor = (
  { isFocused, selectProps }: any,
  theme: DefaultTheme,
  fallback: string,
) => {
  const { status } = selectProps;
  const colorFromStatus = getFieldColorFromStatus({ status, theme });

  if (colorFromStatus) {
    return darken(0.1, colorFromStatus);
  }

  if (isFocused) {
    return theme.colors.primary;
  }

  return fallback;
};

export const getOptionBackgroundColor = ({
  isSelected,
  isFocused,
  theme,
}: any) => {
  if (isSelected || isFocused) {
    return rgba(theme.colors.primary, 0.05);
  }

  return theme.systemColors.defaultBackground;
};

export const $Description = styled.div`
  font-style: italic;
  font-size: ${({ theme }) => theme.fonts.size.megaSmall};
`;

export const $OptionSuffixButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const $SuffixButton = styled.div`
  display: flex;
  height: 20px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.primary};
`;

export const $HighlightedMatch = styled.span`
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  background-color: ${({ theme }) => theme.newUI.variationColors.light4};
`;
